<template>
  <v-container id="notificaciones" tag="section">
    <base-v-component heading="Notificaciones en el sistema" />
    <base-material-card color="indigo" icon="mdi-bell-ring" inline class="px-5 py-3">
      <v-toolbar flat color="white">
        <v-btn
          color="success"
          dark
          class="mb-2"
          @click="goAdd()"
          v-if="role == 'boss_negocio'"
        >Crear Nueva</v-btn>
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="notificaciones"
        :loading="loading"
        :search="search"
        sort-by="fechaCreacion"
        :sort-desc="true"
        v-if="!ordenando"
      >
        <template v-slot:item.acciones="{ item }">
          <v-card-actions class="pa-0 ma-0">
            <v-spacer></v-spacer>
            <v-tooltip top v-if="item.activo">
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="cambiarActivo(item)"
                  :loading="loadingActivo"
                  class="px-2 ml-1"
                  color="green"
                  min-width="0"
                  v-on="on"
                  small
                >
                  <v-icon small>mdi-check</v-icon>
                </v-btn>
              </template>
              <span>Desactivar</span>
            </v-tooltip>
            <v-tooltip top v-else>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="cambiarActivo(item)"
                  v-on="on"
                  class="px-2 ml-1"
                  :loading="loadingActivo"
                  color="red"
                  min-width="0"
                  small
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Activar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="goEdit(item)"
                  v-on="on"
                  class="px-2 ml-1"
                  color="grey"
                  min-width="0"
                  small
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="verRespuestas(item)"
                  v-on="on"
                  class="px-2 ml-1"
                  color="info"
                  min-width="0"
                  small
                >
                  <v-icon small>mdi-book</v-icon>
                </v-btn>
              </template>
              <span>Ver respuestas</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="deleteItem(item)"
                  :loading="loadingBorrar"
                  v-on="on"
                  class="px-2 ml-1"
                  color="red"
                  min-width="0"
                  small
                >
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Borrar notificación</span>
            </v-tooltip>
          </v-card-actions>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>


<script>
import { mostrarIdioma } from "@/utils/utils.js";
import { storage } from "@/firebase";
import { createSlug } from "@/utils/utils.js";
import { mapState, mapGetters, mapActions } from "vuex";
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      search: "",
      ordenando: false,
      loading: false,
      loadingForm: false,
      loadingActivo: false,
      loadingBorrar: false,
      headers: [
        {
          sortable: false,
          text: "Fecha Creación",
          value: "fechaCreacion",
          width: "10%",
        },
        {
          sortable: false,
          text: "Fecha Inicio",
          value: "fechaInicio",
          width: "10%",
        },
        {
          sortable: false,
          text: "Título",
          value: "titulo",
          width: "10%",
        },
        {
          sortable: false,
          text: "Envíos",
          value: "envios",
          width: "10%",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          width: "10%",
          align: "right",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      idiomas: "idiomas",
      langDefecto: "langDefecto",
      notificacionesState: (state) => state.notificaciones.notificaciones,
    }),
    ...mapGetters({
      negocio: "app/negocioGestObj",
      role: "auth/role",
    }),
    notificaciones() {
      return this.notificacionesState.map((n) => {
        return {
          id: n.id,
          activo: n.activo ? n.activo : false,
          fechaInicio: n.hora
            ? moment(n.hora.toDate()).format("DD-MM-YYYY HH:mm")
            : "sin datos",
          fechaCreacion: n.fechaCreacion
            ? moment(n.fechaCreacion.toDate()).format("DD-MM-YYYY HH:mm")
            : "sin datos",
          titulo: n.titulo ? n.titulo : "sin datos",
          envios: n.envios ? n.envios : "sin datos",
        };
      });
    },
  },
  watch: {},
  methods: {
    cambiarActivo(item) {
      var _vm = this;
      _vm.loadingActivo = true;
      this.$store
        .dispatch("notificaciones/changeActivo", {
          id: item.id,
          activo: !(item.activo ? item.activo : false),
        })
        .then((res) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Notificación grabada con éxito",
          });
          return _vm.reload();
          _vm.dialog = false;
        })
        .catch((error) => {
          console.log(error);
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar la notificación",
          });
        })
        .finally(() => {
          _vm.loadingActivo = false;
        });
    },
    mostrarIdioma(str) {
      return mostrarIdioma(str);
    },
    reload() {
      return this.$store.dispatch("notificaciones/getNotificaciones");
    },
    goAdd() {
      let str = "/admin/negocio/notificaciones/add";
      console.log(str);
      this.$router.push(str);
    },
    goEdit(item) {
      let str = "/admin/negocio/notificaciones/add/" + item.id;
      this.$router.push(str);
    },
    verRespuestas(item) {
      let str = "/admin/negocio/notificaciones/respuestas/" + item.id;
      this.$router.push(str);
    },
    deleteItem(item) {
      var _vm = this;

      this.$confirm(
        "¿Desea eliminar esta notificación? Esta acción es irreversible?",
        {
          buttonTrueText: "Aceptar",
          buttonFalseText: "No",
          color: "warning",
          icon: "warning",
          width: 350,
        }
      ).then((res) => {
        if (res) {
          _vm.loadingBorrar = true;
          return this.$store
            .dispatch("notificaciones/deleteNotificacion", {
              id: item.id,
              activo: !(item.activo ? item.activo : false),
            })
            .then((res) => {
              _vm.$store.commit("snackbar/setMensajeSuccess", {
                msj: "Notificación borrada con éxito",
              });
              return _vm.reload();
              _vm.dialog = false;
            })
            .catch((error) => {
              console.log(error);
              _vm.$store.commit("snackbar/setMensajeDanger", {
                msj: "Error al borrar la notificación " + error,
              });
            })
            .finally(() => {
              _vm.loadingBorrar = false;
            });
        }
      });
    },
  },
  mounted() {
    this.reload();
  },
};
</script>

<style>
</style>